export default "__VITE_ASSET__350e04f0__"